export default [
  {
    path: '/pledge-2020/index',
    name: 'index',
    component: () => import('@/views/pledge-2020/index'),
    meta: {
      title: '高考直通车-2020百日誓师'
    }
  },
  {
    path: '/pledge-2020/pledgelist/:province_id',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2020/pledgelist'),
    meta: {
      title: '高考直通车-2020百日誓师'
    }
  },
  {
    path: '/pledge-2020/pledgecard/:id',
    name: 'pledgecard',
    component: () => import('@/views/pledge-2020/pledgecard'),
    meta: {
      title: '高考直通车-2020百日誓师'
    }
  },
  {
    path: '/pledge-2020/pledgesubmit',
    name: 'pledgesubmit',
    component: () => import('@/views/pledge-2020/pledgesubmit'),
    meta: {
      title: '高考直通车-2020百日誓师'
    }
  }
]
